module.exports = __webpack_public_path__ + "img/Airbnb-Enhanced-Focus-Breathing-Circle-Breath.0df97a62.jpg";